import { useRouteData } from "@solidjs/router";
import { Show, onMount } from "solid-js";
import { createStore } from "solid-js/store";
import { ArtworkItem } from "../../Types";
import { loadAds, setPageTitle, setSubMenu } from "../../app";
import { Artwork } from "../../components/artwork";

type State = {
    isContentReady: boolean;
}
export function ArtworkPage() {
    const [state, setState] = createStore<State>({ isContentReady: false } as State);
    const [model, setModel] = createStore<ArtworkItem>({} as ArtworkItem);
    onMount(async () => {
        const routeData = await useRouteData() as any;
        setModel(routeData.model);
        setSubMenu("");
        await loadAds("5th-arc-salon/introduction");
        setPageTitle({ text: `${model.Title} by ${model.Artist}` });
        setState({ isContentReady: true });
    });
    return (
        <>
            <Show when={state.isContentReady}>
                <Artwork model={model} />       
            </Show>
        </>
    )
}